// eslint-disable-next-line import/prefer-default-export
export const LOADING_STATE = {
  INITIAL: "initial",
  LOADING: "loading",
  SUCCESS: "success",
  ERROR: "error",
};
